export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
  content: ArticleContent[];
  isFeatured: boolean;
}

export interface ArticleContent {
  type: 'paragraph' | 'heading' | 'image' | 'quote' | 'list';
  value: string;
  items?: string[];
}

export const articles: Article[] = [
  {
    id: 'art-1',
    title: '2024年度最佳独立游戏推荐：这些冷门神作你玩过几款',
    slug: 'best-indie-games-2024',
    excerpt: '从数百款独立游戏中精选出最值得一玩的10款神作，包括刚刚斩获TGA大奖的《小丑牌》和《动物井》等。每款游戏都有独特的魅力和创新的玩法，绝对值得你花时间去体验。',
    category: 'game-review',
    author: '游戏猎人小明',
    date: '2024-12-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20award%20winning%20indie%20games%202024%2C%20colorful%20game%20covers%20arranged%20artistically%2C%20warm%20lighting%2C%20gaming%20awards%20trophy%2C%20celebratory%20atmosphere%2C%20editorial%20photography%20style&width=1200&height=600&seq=article-best-indie-2024&orientation=landscape',
    tags: ['年度推荐', '独立游戏', '游戏评测', '新游速递'],
    isFeatured: true,
    content: [
      { type: 'heading', value: '引言' },
      { type: 'paragraph', value: '2024年对于独立游戏来说又是一个丰收年。从年初的《小丑牌》风靡全球，到《动物井》以惊人的游戏设计惊艳玩家，再到年底各大游戏奖项对独立游戏的青睐，这一年让我们看到了独立游戏产业的蓬勃生机。今天，我们为大家精选了10款2024年最值得一玩的独立游戏，无论你喜欢什么类型，总有一款适合你。' },
      { type: 'heading', value: '1. 小丑牌（Balatro）—— 扑克与Roguelike的完美融合' },
      { type: 'paragraph', value: '当德州扑克遇上Roguelike，会碰撞出怎样的火花？《小丑牌》给出了答案。这款游戏将经典的扑克牌型机制与Roguelike的牌组构筑深度结合，创造出令人欲罢不能的游戏体验。' },
      { type: 'quote', value: '"这款游戏让我重新理解了扑克的魅力，每一轮都是一次全新的策略挑战。" —— TGA 2024 最佳独立游戏评语' },
      { type: 'paragraph', value: '游戏中有150多种小丑牌，每种都可以提供独特的效果加成。你需要打出合法的扑克牌型来获得筹码，击败一轮轮的盲注挑战。简单易懂的规则下隐藏着深不可测的策略空间，让人一玩就停不下来。' },
      { type: 'heading', value: '2. 动物井（Animal Well）—— 像素艺术下的解谜奇迹' },
      { type: 'paragraph', value: '《动物井》是一款由独立开发者Billy Basso历时7年独自完成的像素风解谜游戏。虽然采用了复古的像素艺术风格，但游戏中的光影效果、物理系统和谜题设计都达到了令人惊叹的高度。' },
      { type: 'paragraph', value: '游戏采用非线性的探索结构，整个地图充满秘密和隐藏区域。很多谜题巧妙地利用了物品之间的互动关系，让人感叹设计者的巧思。这款游戏的核心魅力在于：永远有新的秘密等待你去发现。' },
      { type: 'heading', value: '3. 哈迪斯2（Hades II）—— 众神之战的华丽续章' },
      { type: 'paragraph', value: '作为《哈迪斯》的正统续作，《哈迪斯2》以抢先体验的形式在今年上线。这一次，你扮演的是冥界公主梅利诺厄，在全新的剧情篇章中与时间泰坦克洛诺斯对抗。游戏保留了前作那流畅至极的战斗手感，同时引入了全新的魔法系统和更丰富的祝福组合。' },
      { type: 'heading', value: '总结' },
      { type: 'paragraph', value: '2024年的独立游戏市场给了我们太多惊喜。无论是玩法创新还是艺术表达，独立游戏都在不断突破边界。希望这份推荐能帮助你发现心仪的游戏，开启一段难忘的游戏旅程。' },
    ],
  },
  {
    id: 'art-2',
    title: '星露谷物语1.6更新详解：新内容、新机制与农场规划指南',
    slug: 'stardew-valley-1-6-update',
    excerpt: '期待已久的星露谷物语1.6版本终于上线！新农场类型、新节日、新作物与新道具，还有大量游戏体验优化。本文将为你全面解析这次更新的所有内容。',
    category: 'game-guide',
    author: '农场主老张',
    date: '2024-11-15',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Stardew%20Valley%20new%20farm%20update%20scene%2C%20pixel%20art%20farm%20with%20new%20crops%20and%20buildings%2C%20colorful%20countryside%2C%20warm%20autumn%20atmosphere%2C%20cozy%20gaming%20vibe%2C%20retro%2016%20bit%20aesthetic&width=1200&height=600&seq=article-stardew-update&orientation=landscape',
    tags: ['游戏攻略', '星露谷物语', '版本更新', '农场经营'],
    isFeatured: true,
    content: [
      { type: 'heading', value: '前言' },
      { type: 'paragraph', value: '自2016年发布以来，《星露谷物语》一直在持续更新，而1.6版本无疑是自多人模式上线以来最大的一次内容更新。开发商ConcernedApe（Eric Barone）倾注了大量心血，为这款经典游戏注入了新的活力。让我们一起来看看这次更新带来了哪些令人兴奋的变化。' },
      { type: 'heading', value: '全新农场类型：草甸农场' },
      { type: 'paragraph', value: '1.6版本新增了"草甸农场"（Meadowlands Farm）类型。这个农场拥有特殊的蓝色草地，这种草在收割后会掉落特殊的种子，可以种植出独特的新作物。草甸农场特别适合畜牧业的发展，它会生成更多的动物饲料资源。' },
      { type: 'heading', value: '两个全新节日' },
      { type: 'paragraph', value: '本次更新增加了两个全新的节日活动：春季的"沙漠节"和夏季的"鳟鱼大赛"。沙漠节在春季第15-17日举行，你可以在沙漠中参与各种迷你游戏和挑战；鳟鱼大赛则考验你的钓鱼技巧，优胜者可以获得独家奖励。' },
      { type: 'heading', value: '新增作物、果树与动物' },
      { type: 'paragraph', value: '新版本增加了胡萝卜、西葫芦、甜瓜等新作物，以及木瓜树和柿子树两种新果树。动物方面，新增了"蓝鸡"品种，这种鸡产出的蓝色鸡蛋可以用于制作高级料理。' },
      { type: 'heading', value: '大师级技能系统' },
      { type: 'paragraph', value: '当你的某项技能达到10级后，现在可以通过新的"大师级"系统继续提升。每个技能的大师级都会解锁独特的能力加成，为后期游戏提供了新的目标。例如，耕种大师级可以让你一次性浇灌更大面积的田地。' },
      { type: 'heading', value: '总结' },
      { type: 'paragraph', value: '《星露谷物语》1.6更新为这款已经非常丰富的游戏增添了更多深度和乐趣。无论你是老玩家回归还是新玩家入坑，现在都是探索星露谷的最佳时机。快拿起你的锄头，开始新的田园生活吧！' },
    ],
  },
  {
    id: 'art-3',
    title: '从零开始的独立游戏开发指南：一个独立开发者的心路历程',
    slug: 'indie-game-dev-guide',
    excerpt: '想要开发自己的独立游戏却不知从何下手？本文由一位独立游戏开发者分享他的实战经验与心得，从创意构思到发布推广，手把手教你如何实现游戏开发梦想。',
    category: 'game-guide',
    author: '独立开发者阿杰',
    date: '2024-10-20',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Independent%20game%20developer%20workspace%2C%20computer%20with%20code%20editor%20and%20pixel%20art%2C%20warm%20desk%20lamp%20lighting%2C%20cozy%20creative%20studio%2C%20sketches%20and%20notes%20on%20desk%2C%20inspiring%20atmosphere&width=1200&height=600&seq=article-indie-dev-guide&orientation=landscape',
    tags: ['游戏开发', '独立游戏', '教程指南', '创作者故事'],
    isFeatured: false,
    content: [
      { type: 'heading', value: '写在前面' },
      { type: 'paragraph', value: '三年前，我还是一个朝九晚五的上班族，对游戏开发一窍不通。如今，我已经发布了两款独立游戏，虽然不算大卖，但它们养活了我，让我能继续做自己热爱的事情。这篇文章写给所有想要踏入独立游戏开发领域的朋友们。' },
      { type: 'heading', value: '第一步：找到你的核心创意' },
      { type: 'paragraph', value: '独立游戏最重要的不是技术，而是创意。你的游戏需要有独特的卖点——它能提供什么别人提供不了的体验？我的建议是，从一个简单的核心机制开始，把它做到极致。比如《吸血鬼幸存者》，核心只有一个操作——移动。' },
      { type: 'heading', value: '选择合适的工具' },
      { type: 'paragraph', value: '对于初学者，我强烈推荐使用GameMaker Studio 2或Godot引擎。GameMaker适合2D游戏，学习曲线平缓；Godot完全免费开源，社区极其活跃。Unity和Unreal当然也很强大，但入门门槛更高，建议有一定基础后再尝试。' },
      { type: 'heading', value: '原型验证阶段' },
      { type: 'paragraph', value: '在投入大量时间开发之前，先用最短的时间（建议一周内）做出一个可玩原型。这个原型不需要好看，但要能验证核心玩法是否有趣。邀请朋友试玩，收集反馈。如果核心玩法不够吸引人，果断调整方向。' },
      { type: 'heading', value: '结语' },
      { type: 'paragraph', value: '独立游戏开发是一条艰难但充实的道路。它不会让你一夜暴富，但能给你创造的自由和成就感。如果你有梦想，就从今天开始，哪怕每天只写一行代码。记住：完成比完美重要。' },
    ],
  },
  {
    id: 'art-4',
    title: '空洞骑士深度评测：为什么它是类银河战士恶魔城的巅峰之作',
    slug: 'hollow-knight-deep-review',
    excerpt: '发售多年，《空洞骑士》依然被无数玩家奉为神作。本文将从关卡设计、战斗系统、美术风格、叙事方式等多个维度深入分析这款游戏的魅力所在。',
    category: 'game-review',
    author: '游戏猎人小明',
    date: '2024-09-05',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Hollow%20Knight%20beautiful%20game%20screenshot%2C%20dark%20atmospheric%20underground%20city%2C%20tiny%20knight%20exploring%2C%20blue%20mood%20lighting%2C%20hand%20drawn%20art%20style%2C%20gothic%20architecture%2C%20mysterious%20ambient&width=1200&height=600&seq=article-hollow-knight-review&orientation=landscape',
    tags: ['游戏评测', '空洞骑士', '深度分析', '类银河战士恶魔城'],
    isFeatured: false,
    content: [
      { type: 'heading', value: '前言：一款改变了我对独立游戏认知的作品' },
      { type: 'paragraph', value: '《空洞骑士》是一款由澳大利亚三人团队Team Cherry开发的2D动作冒险游戏。在2017年发布后，它迅速获得了全球玩家的认可和喜爱。如今，它不仅是类银河战士恶魔城类型的标杆之作，更是独立游戏历史上的一座丰碑。' },
      { type: 'heading', value: '关卡设计：开放而有机的探索体验' },
      { type: 'paragraph', value: '圣巢的地图结构是《空洞骑士》最令人惊叹的设计之一。整个地下王国被设计成一个巨大而相互连接的网络，每个区域都有独特的视觉主题、敌人类型和背景音乐。更妙的是，游戏采用了"软引导"的方式，鼓励玩家自由探索而非按固定路线前进。' },
      { type: 'heading', value: '战斗系统：简单但富有深度' },
      { type: 'paragraph', value: '《空洞骑士》的战斗系统表面上很简单——攻击、跳跃、闪避，但在这简单的操作下隐藏着极大的深度。护符系统允许玩家根据战斗风格自由搭配能力，而Boss战的设计更是将这种深度发挥到了极致。' },
      { type: 'heading', value: '美术与音乐：手绘世界的艺术魅力' },
      { type: 'paragraph', value: '游戏全部采用手绘动画制作，每一个场景都像一幅精美的插画。每个区域的色调和氛围都经过精心设计，从翠绿静谧的苍绿之径到阴森诡异的深邃巢穴，视觉风格与游戏体验完美融合。Christopher Larkin创作的原声音乐更是为这个世界注入了灵魂。' },
      { type: 'heading', value: '总结' },
      { type: 'paragraph', value: '《空洞骑士》是一部将关卡设计、战斗系统、美术风格和叙事方式完美融合的作品。它证明了独立游戏可以达到与3A大作比肩的品质，甚至在某些方面更胜一筹。如果你还没有体验过这款游戏，请不要犹豫。' },
    ],
  },
  {
    id: 'art-5',
    title: '杀戮尖塔进阶攻略：从进阶0到进阶20的全角色心得',
    slug: 'slay-the-spire-advanced-guide',
    excerpt: '想要征服进阶20的尖塔巅峰吗？本文整理了铁甲战士、静默猎手、故障机器人和观者四大角色的进阶打法与卡牌评分，助你突破瓶颈。',
    category: 'game-guide',
    author: '爬塔高手老王',
    date: '2024-08-18',
    readTime: '14分钟',
    image: 'https://readdy.ai/api/search-image?query=Slay%20the%20Spire%20card%20selection%20screen%2C%20dark%20tower%20ambiance%2C%20mysterious%20cards%20floating%2C%20character%20silhouettes%2C%20strategic%20card%20game%2C%20atmospheric%20dungeon%20lighting&width=1200&height=600&seq=article-slay-spire-guide&orientation=landscape',
    tags: ['游戏攻略', '杀戮尖塔', '卡牌游戏', '进阶指南'],
    isFeatured: false,
    content: [
      { type: 'heading', value: '写在前面' },
      { type: 'paragraph', value: '《杀戮尖塔》是一款越玩越有深度的游戏。从进阶0到进阶20，每一个阶段都会让你对游戏有新的理解。本文将分享我在征服全角色进阶20过程中的心得与策略，希望能帮助还在爬塔路上的你。' },
      { type: 'heading', value: '铁甲战士：力量与防御的平衡艺术' },
      { type: 'paragraph', value: '铁甲战士是最适合新手的角色，核心机制是力量流和格挡流。低进阶时力量流非常强势，但到了高进阶，纯粹的力量流会遇到瓶颈。建议在进阶15以上时，将力量流与消耗流结合，利用"腐化"+"黑暗之拥"的组合来提升卡组循环效率。' },
      { type: 'heading', value: '静默猎手：毒与飞刀的优雅舞者' },
      { type: 'paragraph', value: '静默猎手的核心在于控制战斗节奏。毒流偏向慢速消耗，飞刀流则追求快速爆发。在进阶20的对抗中，我推荐以毒流为主，搭配弃牌体系来实现攻防一体。"催化剂"是你最强的卡牌，合理使用可以达到一击必杀的效果。' },
    ],
  },
  {
    id: 'art-6',
    title: '吸血鬼幸存者类游戏推荐：2024年最值得一玩的5款肉鸽割草游戏',
    slug: 'vampire-survivors-like-games-2024',
    excerpt: '自从《吸血鬼幸存者》爆火之后，类幸存者游戏层出不穷。本文精心挑选了5款质量上乘的肉鸽割草游戏，让你体验不同的爽快感受。',
    category: 'game-review',
    author: '休闲玩家老王',
    date: '2024-07-22',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Vampire%20Survivors%20style%20games%20collage%2C%20retro%20pixel%20art%20horde%20battles%2C%20colorful%20magic%20effects%2C%20multiple%20game%20characters%2C%20dark%20fantasy%20background%2C%20energetic%20action%20scene&width=1200&height=600&seq=article-survivors-like&orientation=landscape',
    tags: ['游戏推荐', '类幸存者', '肉鸽游戏', '休闲游戏'],
    isFeatured: false,
    content: [
      { type: 'heading', value: '类幸存者游戏：一个小团队创造的品类奇迹' },
      { type: 'paragraph', value: '自2022年《吸血鬼幸存者》以极简的操作和上瘾的玩法征服全球玩家以来，类幸存者（Survivors-like）成为了独立游戏界最热门的品类之一。这类游戏的核心吸引力在于：简单操作、爽快战斗、以及"再玩一把"的上瘾循环。2024年，这个品类涌现出了许多优秀作品。' },
      { type: 'heading', value: '1. 灵魂石幸存者（Soulstone Survivors）' },
      { type: 'paragraph', value: '如果你喜欢《吸血鬼幸存者》但想要更丰富的角色Build系统，《灵魂石幸存者》是完美的升级版。游戏提供了14个各具特色的职业和数百种技能组合，3D画面配合酷炫的技能特效，让割草的爽快感上升了一个层次。' },
      { type: 'heading', value: '2. 死亡必须死（Death Must Die）' },
      { type: 'paragraph', value: '这款游戏将《哈迪斯》的祝福系统巧妙融入了类幸存者玩法中。你可以获得不同神祇的祝福来改变攻击方式，配合装备系统打造独特的Build。游戏的画面风格也向《哈迪斯》致敬，美术品质相当出色。' },
      { type: 'heading', value: '总结' },
      { type: 'paragraph', value: '类幸存者游戏之所以如此受欢迎，是因为它们抓住了游戏最本质的乐趣——简单、直接、爽快。2024年的这些新作在保留核心乐趣的同时，各自加入了独特的创新元素。如果你喜欢这个品类，以上5款游戏都值得一试。' },
    ],
  },
];

export const getFeaturedArticles = (): Article[] => {
  return articles.filter(article => article.isFeatured);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find(article => article.id === id);
};

export const getRecentArticles = (count: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};